import React from 'react'
import CreateEntryForm from "../components/CreateEntryForm"

function CreateEntryPage() {
  return (
    <div className="create-entry-page-div">
        <div className='create-entry-form-div'>
          <CreateEntryForm />
        </div>
    </div>
  )
}

export default CreateEntryPage